import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const TX_CALLBACK_REQUEST = 'TX_CALLBACK_REQUEST'
export const TX_CALLBACK_SUCCESS = 'TX_CALLBACK_SUCCESS'
export const TX_CALLBACK_FAILURE = 'TX_CALLBACK_FAILURE'
export const TX_CALLBACK_RESET = 'TX_CALLBACK_RESET'

export function transactionCallback(txId) {
  return {
    [CALL_API]: {
      endpoint: '/api/transactions/' + txId + '/make-callback/',
      types: [TX_CALLBACK_REQUEST, TX_CALLBACK_SUCCESS, TX_CALLBACK_FAILURE],
      method: 'POST',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}

export function resetTransactionCallback() {
  return {
    type: TX_CALLBACK_RESET,
  }
}
